import { getToken } from "store";

export async function subscribeUser() {
    if ("serviceWorker" in navigator && "PushManager" in window) {
        try {
            // Register the service worker
            const registration = await navigator.serviceWorker.register("/sw.js");
            
            // Wait for the worker to be active
            if (registration.active) {
                // Worker is already active
                return await doSubscription(registration);
            }
            
            // If not active yet, wait for it to activate
            const activeRegistration = await navigator.serviceWorker.ready;
            return await doSubscription(activeRegistration);
            
        } catch (error) {
            console.error("Service Worker registration failed:", error);
            throw error;
        }
    }
}

async function doSubscription(registration) {
    try {
        // Convert VAPID key properly
        const applicationServerKey = urlBase64ToUint8Array(
            "BHJ3pvbi2mR_KEcwbALtmzRkzl3PWY12s2---CgYTMGrapCfp4Ol5U0DqUcDD1YKbGkVqpP66Wjg3diqCDslZGU"
        );

        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey
        });

        const token = getToken();
        const apiUrl = new URL(process.env.REACT_APP_API_URL);
        apiUrl.pathname = '/push/subscribe';
        
        // console.log("Subscribing with:", { subscription, endpoint: apiUrl.toString() });

        const response = await fetch(apiUrl.toString(), {
            method: "POST",
            headers: { 
                "Content-Type": "application/json", 
                "x-auth": token 
            },
            body: JSON.stringify(subscription),
        });

        if (!response.ok) {
            throw new Error(`Server responded with ${response.status}`);
        }
        
        return subscription;
    } catch (error) {
        console.error("Push subscription failed:", {
            name: error.name,
            message: error.message,
            stack: error.stack,
            statusCode: error.statusCode,
            body: error.body,
            headers: error.headers
        });
        throw error;
    }
}

// Helper function for VAPID key conversion
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}